<template>
  <admin-wrapper title-translation-path="admin.dictionariesSettings" :has-buttons="false" :inputs="inputs">
    <template #dictionaries.input>
      <v-row no-gutters>
        <v-col cols="8">
          <DictionariesSettingsList />
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import DictionariesSettingsList from '@/components/DictionariesSettingsList';

export default {
  name: 'DictionariesSettings',
  components: {
    AdminWrapper,
    DictionariesSettingsList,
  },
  computed: {
    inputs() {
      return [
        {
          align: 'baseline',
          name: 'dictionaries',
          translationPath: 'admin.dictionariesList',
        },
      ];
    },
  },
};
</script>
